import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HospitalXService, MasterService } from '../../api';
import { Camera, Errors } from '../../interfaces';
import { SnackService } from '../../services';

@Component({
  selector: 'school-camera-form',
  templateUrl: './camera-form.component.html',
  styleUrls: ['./camera-form.component.scss']
})
export class CameraFormComponent implements OnInit {

  cameraFormValue = {} as Camera;
  errMsg = {} as Errors;

  @Input() cameraId: number;
  @Input() formtype: any;
  @Output() accordionEvent = new EventEmitter();
  @Output()
  cancelEvent = new EventEmitter<string>();

  cameraType_list: any = [];

  @ViewChild("cameraform", { static: false }) camerasform: NgForm;

  constructor(
    private _snackService: SnackService,
    private _masterService: MasterService,
    private _userService: HospitalXService,) { }

  ngOnInit(): void {
    this.cameraFormValue.camera_ip_type = "Private";
  }

  ngAfterViewInit() {
  }

  ngOnChanges(): void {

    this.cameraType();
    if (this.formtype == true) {
      this.LoadData(this.cameraId);
    }
  }

  ngOnDestroy(): void {
    this.accordionEvent.unsubscribe();
  }

  viewCameralist() {
    this.cancelEvent.emit();
  }

  cameraType(): void {

    this._masterService.getMasterBySlugList('camera').subscribe(
      result => {
        this.cameraType_list = result.body.data.masters;
      }, error => {
        this._snackService.openSnackBar("danger", "Failed to Load camera Data...");
        console.log(error);
      });

  }

  LoadData(id: number): void {

    this._userService.getCamerasInfo(id).subscribe(
      result => {
        this.cameraFormValue = result.body.data.cameras;


      }, error => {
        this._snackService.openSnackBar("danger", "Failed to Load Data...");
        console.log(error);
      });
  }

  onSubmit(): void {
    if (this.formtype == true) {
      this.updateData();
    }
    else {
      this.saveData();
    }
  };

  saveData(): void {


    const saveData = { ...this.cameraFormValue };

    this._userService.saveCameras(saveData).subscribe(
      result => {

        this.camerasform.resetForm();
        this._snackService.openSnackBar("success", "Camera Added Successfully!...");
        this.errMsg = {};
        this.viewCameralist();

      }, error => {
        this._snackService.openSnackBar("danger", "Failed to add a new Camera...");
        this.errMsg = error.error.data.errors;
      });

  }

  updateData(): void {

    this.cameraFormValue.camera_id = this.cameraId;

    const saveData = { ...this.cameraFormValue };

    this._userService.PatchCameras(saveData).subscribe(
      result => {

        this.camerasform.resetForm();
        this._snackService.openSnackBar("success", "Camera updated Successfully!...");
        this.errMsg = {};
        this.viewCameralist();

      }, error => {
        this._snackService.openSnackBar("danger", "Failed to update Camera...");
        this.errMsg = error.error.data.errors;
      });

  }


}
